(() => {
  const configNode = document.getElementById('toku-campaign-copy');
  if (!configNode || !document.documentElement.lang.toLowerCase().startsWith('en')) return;
  const copy = JSON.parse(configNode.textContent);
  const observed = new WeakSet();
  const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`__${key}__`, value), template);
  const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const translateDiscount = element => {
    const value = element.textContent.trim();
    const match = value.match(/^(?:%(\d+(?:[.,]\d+)?)|(\d+(?:[.,]\d+)?)%)\s+indirim$/i);
    if (match) setText(element, format(copy.off, { percent: match[1] || match[2] }));
  };
  const attach = host => {
    if (observed.has(host)) return;
    observed.add(host);
    customElements.whenDefined('dmixer-quantity-options').then(() => {
      const root = host.shadowRoot;
      if (!root) return;
      const observer = new MutationObserver(update);
      function update() {
        observer.disconnect();
        root.querySelectorAll('[part="badge-text"]').forEach(element => {
          const match = element.textContent.trim().match(/^(\d+(?:[.,]\d+)?)%\s+tasarruf edin$/i);
          if (match) setText(element, format(copy.save, { percent: match[1] }));
        });
        if (copy.pair && host.closest('main')) {
          root.querySelectorAll('.dmixer-qo__tier-title').forEach(element => {
            const match = element.textContent.trim().match(/^Buy (\d+\+?)$/);
            if (match) setText(element, format(copy.buy_pairs, { count: match[1] }));
          });
          root.querySelectorAll('.dmixer-qo__per-item').forEach(element => {
            if (element.textContent.endsWith(' per item')) setText(element, element.textContent.replace(/ per item$/, ` ${copy.per_pair}`));
          });
          root.querySelectorAll('.dmixer-qo__cta .dmixer-widget-button__text').forEach(element => {
            const match = element.textContent.trim().match(/^Add (\d+) items?$/);
            if (match) setText(element, format(copy.add_pairs, { count: match[1], pieces: Number(match[1]) * 2 }));
          });
          const heading = root.querySelector('h3');
          if (heading && !root.querySelector('[data-toku-pair-note]')) {
            const note = document.createElement('p');
            note.setAttribute('data-toku-pair-note', '');
            note.textContent = copy.pair_note;
            note.style.cssText = 'font:inherit;font-size:13px;line-height:1.5;margin:0 0 10px;color:inherit';
            heading.after(note);
          }
        }
        observer.observe(root, { subtree: true, childList: true, characterData: true });
      }
      update();
    });
  };
  const scan = root => {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    if (root.matches?.('.discount-title')) translateDiscount(root);
    root.querySelectorAll('.discount-title').forEach(translateDiscount);
    if (root.matches?.('dmixer-quantity-options')) attach(root);
    root.querySelectorAll('dmixer-quantity-options').forEach(attach);
  };
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => {
      record.addedNodes.forEach(scan);
      if (record.target.nodeType === Node.ELEMENT_NODE && record.target.matches('.discount-title')) translateDiscount(record.target);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
